// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__384F1","content":"styles_content__3_VBS","selectAll":"styles_selectAll__25svW"};